/* VÀLIEN — blog etkileşim · 24.09.2026 (v3): adım şeridi sekme + açıklama paneli (genel kullanım notu yedekli) */
(function () {
  const baslat = () => {
    const govde = document.querySelector('.blog-post-content.rte');
    if (!govde) return;
    const kucuk = (s) => (s || '').toLocaleLowerCase('tr');
    const SOZLUK = [
      [['sabun', 'temizl', 'jel', 'köpük'], 'Yüzü ılık suyla ıslatın. Temizleyiciyi köpürtüp yaklaşık 30 saniye nazikçe yayın, bol suyla durulayın ve havluyla bastırarak kurulayın.'],
      [['peeling', 'arındır'], 'Islak yüze, parmak uçlarıyla, bastırmadan uygulayın. Göz çevresinden uzak durun, ardından iyice durulayın.'],
      [['toner', 'pad', 'tonik'], 'Temiz ve kurulanmış cilde, pad\'i içten dışa doğru bir kez geçirin. Durulamayın; kuruyunca sonraki adıma geçin.'],
      [['serum', 'esans', 'ampul'], 'Birkaç damlayı avucunuza alın, yüze bastırarak yayın. Emilmesini bekleyip sonraki adıma geçin.'],
      [['nemlendir', 'krem', 'losyon'], 'Rutinin son adımı. Nohut büyüklüğünde bir miktarı yüz ve boyna ince bir katman hâlinde yayın, bastırarak yedirin.'],
      [['maske'], 'Temiz cilde ince bir katman uygulayın ve ambalajdaki süreye göre bekleyin.'],
      [['güneş', 'spf'], 'Sabah rutininin son adımı. Yüzün tamamına yeterli miktarda sürün, gün içinde yenileyin.']
    ];
    const genelNot = (ad) => { const a = kucuk(ad); const k = SOZLUK.find(([anahtar]) => anahtar.some((x) => a.includes(x))); return k ? k[1] : ''; };
    const satirlar = [...govde.querySelectorAll('table tbody tr')].map((tr) => [...tr.children].map((td) => td.textContent.trim()));
    const baslik = [...govde.querySelectorAll('table thead th')].map((th) => th.textContent.trim());
    const paragraflar = [...govde.querySelectorAll('p:not(.vm-gizli)')];
    document.querySelectorAll('ol.vm-sira').forEach((ol) => {
      if (ol.dataset.hazir) return;
      ol.dataset.hazir = '1';
      const adimlar = [...ol.querySelectorAll('.vm-sira__adim')];
      const panel = document.createElement('div');
      panel.className = 'vm-sira__panel';
      panel.setAttribute('role', 'tabpanel');
      panel.setAttribute('aria-live', 'polite');
      ol.after(panel);
      ol.setAttribute('role', 'tablist');
      const icerik = (ad) => {
        const a = kucuk(ad);
        const kok = a.slice(0, Math.max(4, a.length - 2));
        const ai = baslik.findIndex((b) => /adım/i.test(b));
        const satir = satirlar.find((s) => ai > -1 && kucuk(s[ai]).startsWith(kok))
          || satirlar.find((s) => kucuk(s[0]).split(' ').some((w) => w.startsWith(kok)))
          || satirlar.find((s) => s.some((h) => kucuk(h).split(/[\s,]+/).some((w) => w.startsWith(kok) && w.length <= kok.length + 3)));
        const p = paragraflar.find((x) => !x.closest('.vm-sira') && !x.closest('.vm-sira__panel') && kucuk(x.textContent).includes(kok) && x.textContent.length < 400);
        return { satir, p };
      };
      const sec = (i) => {
        adimlar.forEach((li, j) => { li.classList.toggle('is-aktif', i === j); li.classList.toggle('is-gecti', j < i); li.setAttribute('aria-selected', i === j); });
        const ad = adimlar[i].querySelector('.vm-sira__ad').textContent.trim();
        const { satir, p } = icerik(ad);
        panel.innerHTML = '';
        const ust = document.createElement('p');
        ust.className = 'vm-sira__panel-ust';
        ust.textContent = String(i + 1).padStart(2, '0') + ' · ' + ad;
        panel.append(ust);
        if (satir) {
          const dl = document.createElement('dl');
          satir.forEach((h, j) => { if (!h || !baslik[j]) return; const dt = document.createElement('dt'); dt.textContent = baslik[j]; const dd = document.createElement('dd'); dd.textContent = h; dl.append(dt, dd); });
          panel.append(dl);
        }
        const metin = genelNot(ad) || (p ? p.textContent.trim() : '');
        if (metin) { const q = document.createElement('p'); q.className = 'vm-sira__panel-metin'; q.textContent = metin; panel.append(q); }
        panel.classList.remove('is-gir'); void panel.offsetWidth; panel.classList.add('is-gir');
      };
      adimlar.forEach((li, i) => {
        li.setAttribute('role', 'tab');
        li.tabIndex = 0;
        li.addEventListener('click', () => sec(i));
        li.addEventListener('keydown', (e) => {
          if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); sec(i); }
          if (e.key === 'ArrowRight' || e.key === 'ArrowDown') { e.preventDefault(); const n = adimlar[Math.min(i + 1, adimlar.length - 1)]; n.focus(); n.click(); }
          if (e.key === 'ArrowLeft' || e.key === 'ArrowUp') { e.preventDefault(); const n = adimlar[Math.max(i - 1, 0)]; n.focus(); n.click(); }
        });
      });
      sec(0);
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => setTimeout(baslat, 50));
  else setTimeout(baslat, 50);
  setTimeout(baslat, 1600);
})();
